import RestaurantOther, { Slider } from './RestaurantOther';

export { Slider };
export default RestaurantOther;
